<template>
  <b-row
    align-v="center"
    @mouseover="setContextOnHover(contextHelpRoot+'Z')"
    @mouseleave="setContextOnHover(contextHelpRoot+'Z')"
  >
    <b-col>
      <p class="label">
        {{ axis }}-axis (Z)
      </p>
    </b-col>
    <b-col>
      <SimpleDropdownConfiguration :controller="InputZ" />
    </b-col>
    <b-col>
      <SimpleDropdownConfiguration :controller="OutputZ" />
    </b-col>
    <b-col>
      <CheckBoxConfiguration
        :controller="Log_axis"
        :switchprop="true"
      />
    </b-col>
  </b-row>
</template>

<script>
import {comboBoxConfCtrller, checkBoxGraphConfCtrller} from '@/assets/classes/configuration.js'
import SimpleDropdownConfiguration from '../elements/SimpleDropdownConfiguration'
import CheckBoxConfiguration from '../elements/CheckBoxConfiguration'
import { TypeAxis, ConfigName } from '@/common/plotDefinitions.js'
import { mapActions } from 'vuex'

const contextHelpRoot='ReportViewer/Units/'

export default {
  name: 'ImpedanceConfiguration',
  components: { 
    SimpleDropdownConfiguration,
    CheckBoxConfiguration
  },
  props: {
    axis:{
      type:String,
      required:true
    },
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data () {
    return {
      elementsConfig:[],
      InputZ: new comboBoxConfCtrller(TypeAxis.impedance.inputConfig,
      [
        {text:'GΩ',value:9},
        {text:'MΩ',value:6},
        {text:'kΩ',value:3},
        {text:'Ω',value:0},
        {text:'mΩ',value:-3},
        {text:'μΩ',value:-6}
      ],'',2,`${contextHelpRoot}InputImpedance`,true),
      OutputZ:new comboBoxConfCtrller(TypeAxis.impedance.outputConfig,
      [
        {text:'GΩ',value:9},
        {text:'MΩ',value:6},
        {text:'kΩ',value:3},
        {text:'Ω',value:0},
        {text:'mΩ',value:-3},
        {text:'μΩ',value:-6}
      ],'',2,`${contextHelpRoot}OutputImpedance`,true),
      Log_axis: new checkBoxGraphConfCtrller(`${ConfigName.BaseAxisProperties}.LOG{0}_BOOL`,'',false,contextHelpRoot+'Log_axis'),
      contextHelpRoot
    }
  },
  mounted(){
    this.elementsConfig=[
      this.InputZ,
      this.OutputZ,
      this.Log_axis
    ]
    this.Log_axis.formatKeyValue(this.axis)
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
  methods:mapActions(['setContextOnHover','setConfigReportModifiedReportViewer']),
}
</script>

<style lang="scss" scoped>
.label{
  margin:0px;
  font-size: 0.8rem;
}

.header{
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}
::v-deep .label-input-text{
  font-size: 0.8rem;
}
</style>
